import React from "react";
import { Card } from "../../../common";

export const BillingWrapper = () => {
  return (
    <Card classes="w-full md:col-start-1 md:col-end-10 flex justify-between">
      <div>
        <h3 className="text-left text-f24 text-primary font-bold">
          Billing
        </h3>
        <p className="text-left text-f16 text-secondarytwo mb-4">
          Update your payment information or switch plans according to your
          needs
        </p>
      </div>
    </Card>
  );
};
